module.exports = __webpack_public_path__ + "static/Image_1A-35e9ace40e6ad888e7258afbaa356c33.png";